import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import _ from 'lodash'
import { RootState } from '../types'
import { TrelloCard, TrelloMember } from '@/TrelloClient'
import { TrelloConfig } from '@/config'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
    state: {
        trello: null,
        activeMemberId: null,
        openCards: [],
        activeCard: {
            id: 'Not set',
            name: 'Not set',
            shortUrl: new URL('https://www.trello.com'),
            due: 'Not set',
            board: {
                id: 'Not set',
                name: 'Not set',
                shortUrl: new URL('https://www.trello.com'),
            },
            desc: '',
            labels: [],
        },
        activeLabel: null,
        authorizedMember: {
            id: 'Not set',
            fullName: 'Not set',
            email: 'Not set',
            idBoards: [],
        },
        activeCardFilters: [],
    },
    getters: {
        filteredOpenCards: (state) => {
            let filteredCards = state.openCards
            state.activeCardFilters.forEach((cardFilter) => {
                filteredCards = filteredCards.filter(cardFilter.filter)
            })
            return filteredCards
        },
        trelloClientReady: state => state.trello !== null,
    },
    mutations: {
        updateTrelloClient(state, trelloClient) {
            state.trello = trelloClient
        },
        updateActiveMemberId(state, activeMemberId) {
            state.activeMemberId = activeMemberId
        },
        updateOpenCards(state, openCards) {
            state.openCards = openCards
        },
        updateOpenCardDueDate(state, { cardId, dueDate }) {
            let cardIndex = state.openCards.map(x => x.id).indexOf(cardId)
            if (cardIndex !== -1) {
                state.openCards[cardIndex].due = dueDate
            }
        },
        updateActiveCard(state, activeCard) {
            state.activeCard = activeCard
        },
        updateActiveLabel(state, activeLabel) {
            state.activeLabel = activeLabel
        },
        updateAuthorizedMember(state, member) {
            state.authorizedMember = member
        },
        updateCardFilter(state, { type, filter }) {
            // Elimina i filtri dello stesso tipo già esistenti
            state.activeCardFilters = state.activeCardFilters.filter(f => f.type !== type)
            // Aggiungi il nuovo filtro
            state.activeCardFilters.push({ type, filter })
        },
        removeCardFilter(state, { type }) {
            state.activeCardFilters = state.activeCardFilters.filter(f => f.type !== type)
        },
    },
    actions: {
        /**
         * Prendi la card completa da Trello e imposta la card attiva
         */
        fetchActiveCard({ commit, state }, activeCardId: string) {
            return new Promise((resolve) => {
                state.trello!.fetchCard(activeCardId, ['all'], ['name']).then((fetchedCard) => {
                    commit('updateActiveCard', fetchedCard)
                    console.log('Card attiva cambiata in ' + (fetchedCard as TrelloCard).shortUrl)
                    resolve(fetchedCard)
                })
            })
        },
        /**
         * Prendi il membro attualmente autorizzato con Trello ed imposta lo stato
         */
        fetchAuthorizedMember({ commit, state }) {
            return new Promise((resolve) => {
                state.trello!.fetchMyself().then((fetchedMember) => {
                    commit('updateAuthorizedMember', fetchedMember)
                    console.log('Il membro autorizzato è ' + (fetchedMember as TrelloMember).fullName)
                    resolve(fetchedMember)
                })
            })
        },
        /**
         * Prendi da Trello tutte le card aperte di un membro
         *
         * Il payload deve contenere l'ID del membro e la funzione
         * da usare per filtrare l'array delle card aperte ritornate
         * da Trello (opzionale).
         */
        fetchOpenCards({ commit, state }, { memberId }) {
            return new Promise((resolve) => {
                state.trello!.fetchMemberOpenCardsAcrossBoards(
                    memberId,
                    ['name', 'shortUrl', 'due', 'labels'],
                    200,
                    TrelloConfig.boardsToShow,
                ).then((cards) => {
                    let nBoards = [...new Set((cards as TrelloCard[]).map(x => x.board.id))].length
                    console.log('Preso card aperte da ' + nBoards + ' board di Trello')
                    commit('updateOpenCards', cards)
                    resolve(cards)
                })
            })
        },
    },
    modules: {
    },
}

export default new Vuex.Store<RootState>(store)
